module.exports = __webpack_public_path__ + "img/message_ios.fbf94ae0.png";